import { Box } from '@mui/material';

function LocationBox() {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '90vh' }}>
      {/* Some header or other content */}
      <Box sx={{ flex: 1, display: 'flex' }}>
        <iframe
          title="Google Maps"
          style={{ border: 0, width: '100%', height: '100%' }}
          loading="lazy"
          allowFullScreen
          src="https://www.google.com/maps/embed/v1/place?key=AIzaSyBMF_DtFq474EYL-U0LG3LL_cB_FI-J-ds&q=Helmitauluntie+7"
        ></iframe>
      </Box>  
    </Box>
  );
}

export default LocationBox;